import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as filters from './filters' // global filters
import { removeToken, removeStation } from '@/utils/auth' 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './permission'

import '@/styles/fonts/css/font-awesome.min.css'
import '@/styles/index.sass' // global css
// import {
//   Upload,Input,Autocomplete,Tabs,TabPane,
// } from 'element-ui'
// Vue.use(Upload)
// Vue.use(Input)
// Vue.use(Autocomplete)
// Vue.use(Tabs)
// Vue.use(TabPane)

// import Common from '../../common/index.js'
// Vue.use(Common)
import VueI18n from 'vue-i18n'
import messages from '@/i18n/index.js'
Vue.use(VueI18n)

let lang = localStorage.getItem(`${process.env.MODULE}_lang`);
if(!lang){
  lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
  lang = lang.substr(0, 2);//截取lang前2位字符
  lang = lang == 'zh' ? 'zh' : 'en' 
  localStorage.setItem(`${process.env.MODULE}_lang`, lang)
}

const i18n = new VueI18n({
  // 从本地存储中取，如果没有默认为中文，
  // 这样可以解决切换语言后，没记住选择的语言，刷新页面后还是默认的语言
  locale: lang,
  messages
})

Vue.config.productionTip = false
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(ElementUI);
//hznet/power-distribution
Vue.config.requestPath = process.env.NODE_ENV == "development" ? '/power-distribution' : '/power-distribution';
// Vue.config.requestPath = process.env.NODE_ENV == "development" ? '/power-distribution' : '/hznet';
Vue.config.requestPath_photovoltaic = process.env.NODE_ENV == "development" ? '/power-distribution' : '/power-distribution';

console.log(Vue.config.requestPath)
hz.ajax.defaultErrorMessage = '网络异常，请重新刷新页面或者重新操作！<br>若问题再次出现，请联系技术人员。';
hz.ajax.callbackSuccess = function(res){
  if(typeof res == 'string'){
    res = JSON.parse(res);
    if(res.code == 'HZ000001'){
      removeToken();
      removeStation();
      location.reload();
      return false
    }
  }
  return true;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js